$(function () {
    if ($('.fullwidthcta__carousel').length > 0) {
        $('.fullwidthcta__carousel').owlCarousel({
            loop: true,
            margin: 0,
            responsive: {
                0: {
                    items: 1,
                    nav: false,
                    dots: true
                },
                560: {
                    items: 1,
                    nav: true,
                    dots: true
                }
            },
            autoplay: true,
            autoplayspeed: 3000
        });

        //can't find a way to only have arrows
        $('.owl-prev').text('');
        $('.owl-prev').html('<i class="fa fa-angle-left"></i>');
        $('.owl-next').text('');
        $('.owl-next').html('<i class="fa fa-angle-right"></i>');
    }
});